
import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import Echarts from "echarts-for-react";
import {
  getDate,
  getTime,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { useWindowSize } from "services/resizeservice";

export default function EnergyComponent(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  const { swappedSessionGraphData } = props;

  var xAxisData = [];
  var yAxisHardwareError = [];
  var yAxisDataLabel = [];
  var yAxisTemptError = [];
  
  if (props.swappedSessionGraphData != undefined) {
    props.swappedSessionGraphData.map(function (obj) {
      if (
        props.selectTimeValue === "HOUR_24" ||
        props.selectTimeValue === "HOUR_12"
      ) {
        xAxisData.push(getTime(obj.endDate));
      } else if (props.selectTimeValue === "WEEK") {
        xAxisData.push(getDay(obj.endDate));
      } else {
        xAxisData.push(getDate(obj.endDate));
      }
      yAxisHardwareError.push(obj.yaxis === "0" ? '' : obj.yaxis)
      yAxisDataLabel.push(obj.yaxis)
      
      // yAxisTemptError.push(obj.temperatureError);
    });
  }

  // if (props.selectTimeValue == "168") {
  //   xAxisData = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  // }

  var option = {
    tooltip: {
      trigger: "item",
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      name: "Time",
      nameLocation: "middle",
      nameGap: 30,
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
    },
    axisLabel: {
      rotate:
        props.selectTimeValue === "WEEK_2" ||
        props.selectTimeValue === "MONTH" ||
        props.selectTimeValue === "MONTH_3"
          ? 30
          : 0,
    },
    yAxis: {
      type: "value",
      name: "No. of Swaps",

      nameLocation: "middle",
      nameGap: props.selectTimeValue === "WEEK_2" ? 30 :
      props.selectTimeValue === "MONTH" ? 37 :
      props.selectTimeValue === "MONTH_3" ? 37 : 32 ,
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
    },
    grid: {
      left: "13%",
      right: "3%",
      bottom: "20%",
      top: 40,
      containLabel: true,
      show: true,
      width: "auto",
    },
    series: [
      {
        type: "bar",
        itemStyle: {
          borderColor: "transparent",
          color: "transparent",
        },
        emphasis: {
          itemStyle: {
            borderColor: "transparent",
            color: "transparent",
          },
        },
        data: yAxisDataLabel,
      },
      {
        type: "bar",
        showBackground: true,
        backgroundStyle: {
          color: "transparent",
        },
        label: {
          show: true,
          position: "top",
        },
        color: "#087A3E",
        data: yAxisHardwareError,
      },
      // {
      //   // data: yAxisChargedData,
      //   // data:swappedSessionGraphData,
      //   // data: [100, 82, 65, 60, 50, 42, 30, 25],
      //   data: yAxisHardwareError,
      //   type: "bar",
      //   color: "#087A3E",
      //   // color: '#00FF00',
      //   label: {
      //     show: true,
      //     position: "top",
      //   },
        
      //   emphasis: {
      //     itemStyle: {
      //       shadowBlur: 10,
      //       shadowOffsetX: 0,
      //       shadowColor: "rgba(0, 0, 0, 0.5)",
      //     },
      //   },
      // },
    ],
  };

  return (
    // <div style={{ width: "auto" }}>
    <Echarts
      styles={{ with: "100%", height: "80%" }}
      option={option}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
      notMerge={true}
      lazyUpdate={true}
    />
    // </div>
  );
}
